/**
 * Texto COLADO com várias linhas no campo de novo item do checklist vira
 * vários itens (SPEC-20261010-1307-colar-varias-linhas-no-checklist, pedido do
 * Cristian: "quando incluir no campo com quebras de linha deve criar vários
 * itens de checklist").
 *
 * Cada linha não vazia é um item, na ordem colada. Marcadores de lista no
 * começo da linha (-, *, •, "1.", "a)", "[ ]", "[x]") saem — são da lista de
 * onde o texto veio, não do item.
 */
const MARCADOR = /^\s*(?:[-*•▪◦·–—]|\d{1,3}[.)]|[a-zA-Z][.)](?=\s)|\[[ xX]?\])\s+/

export function linhasColadas(texto: string): string[] {
  return texto
    .split(/\r?\n/)
    .map((linha) => linha.replace(MARCADOR, '').replace(/\s+/g, ' ').trim())
    .filter((linha) => linha !== '')
}
